// SketchCameraToolbar — Fusion 360-style панель навигации внизу sketch-mode.
//
// Кнопки:
//   ✋ Pan      — toggle: курсор → grab, ЛКМ-drag по сцене двигает камеру
//   🔄 Orbit    — toggle: показывает 3 круга-gizmo, drag по кругу крутит вокруг оси
//   🔍+ Zoom in
//   🔍- Zoom out
//   ⊕  Fit      — вернуть камеру в центр эскиза
//
// Pan/Orbit — взаимоисключающие. Активный режим — в store.cameraTool.
// Сами тяги (drag по сцене) обрабатывает CameraToolOverlay в Viewport.

import React from 'react';
import useCadStore from '../store/useCadStore';
import cl from './SketchCameraToolbar.module.css';


const SketchCameraToolbar = () => {
    const cameraTool = useCadStore((s) => s.cameraTool);
    const setCameraTool = useCadStore((s) => s.setCameraTool);

    const callApi = (method, ...args) => {
        const api = window.__kubikonCadCamera;
        if (!api || typeof api[method] !== 'function') return;
        try { api[method](...args); } catch (_) {}
    };

    const togglePan = () => {
        setCameraTool(cameraTool === 'pan' ? null : 'pan');
    };
    const toggleOrbit = () => {
        setCameraTool(cameraTool === 'orbit' ? null : 'orbit');
    };

    return (
        <div className={cl.toolbar}>
            <button
                className={`${cl.btn} ${cameraTool === 'pan' ? cl.btnActive : ''}`}
                title="Перемещение (зажми и тащи по сцене)"
                onClick={togglePan}
            >
                <span className={cl.icon}>✋</span>
            </button>

            <button
                className={`${cl.btn} ${cameraTool === 'orbit' ? cl.btnActive : ''}`}
                title="Вращение (тяни круги-gizmo)"
                onClick={toggleOrbit}
            >
                <span className={cl.icon}>🔄</span>
            </button>

            <div className={cl.sep}/>

            <button
                className={cl.btn}
                title="Приблизить"
                onClick={() => callApi('zoomIn')}
            >
                <span className={cl.icon}>🔍</span>
                <span className={cl.plus}>+</span>
            </button>

            <button
                className={cl.btn}
                title="Отдалить"
                onClick={() => callApi('zoomOut')}
            >
                <span className={cl.icon}>🔍</span>
                <span className={cl.plus}>−</span>
            </button>

            <div className={cl.sep}/>

            <button
                className={cl.btn}
                title="По размеру (вернуть камеру)"
                onClick={() => callApi('fit')}
            >
                <span className={cl.icon}>⊕</span>
            </button>
        </div>
    );
};

export default SketchCameraToolbar;
